import styles from './footer.module.css';
import telegramImage from '../../images/telegram.svg';
import twitterImage from '../../images/twitter.svg';
import IconButton from '@mui/material/IconButton';

function Footer() {
    return (
        <div className={`${styles.container}`}>
            <div className={`${styles.footerText}`}>
                © 2021 Amasa. All rights reserved.
            </div>
            <div className={`${styles.socials}`}>
                <div>
                    <IconButton aria-label="Telegram" onClick={() => window.open("https://t.me/amasa_community")}>
                        <img alt="" src={telegramImage}/>
                    </IconButton>
                </div>
                <div>
                    <IconButton aria-label="Twitter" onClick={() => window.open("https://twitter.com/Amasa_io")}>
                        <img alt="" src={twitterImage}/>
                    </IconButton>
                </div>
            </div>
        </div>
    );
}

export default Footer;
